const deviceKey = (store, email) => `mgmt_trusted_device:${store}:${String(email || "").trim().toLowerCase()}`;

export const getDeviceToken = (store, email) => {
  try {
    return localStorage.getItem(deviceKey(store, email))
      || (store === "staff" ? localStorage.getItem("cps_device_token") : "")
      || undefined;
  } catch {
    // The server-issued HttpOnly cookie remains a fallback when browser script
    // storage is unavailable or was purged. Never block password sign-in here.
    return undefined;
  }
};

export const saveDeviceToken = (store, email, token) => {
  if (!token || !email) return;
  try { localStorage.setItem(deviceKey(store, email), token); } catch { /* cookie fallback */ }
};

export const rememberLoginDevice = (store, loginEmail, data) => {
  saveDeviceToken(store, loginEmail, data?.device_token);
  saveDeviceToken(store, data?.user?.email, data?.device_token);
};